import { Security } from "../proto/generated/security";
import { getFutures, getPastExpiries } from "../services/apis/optionChain";

export const fetchFutureExpiries = async (underlying: Security) => {
    const [currentFutures, pastExpiries] = await Promise.all([getFutures(underlying), getPastExpiries(underlying)]);
    window.securityManager.addSecurities(pastExpiries.futureSecurities.map(fs => fs.security!));
    return [currentFutures.futureSecurities, pastExpiries.futureSecurities]
}